import React, { useState } from 'react';
import Navbar from './components/Navbar';
import Routes from './Routes';
import { BrowserRouter as Router } from 'react-router-dom';
import { ChatBotProvider } from './context/ChatBotContext';

const App = () => {
    const [profileOption, setProfileOption] = useState('dailyreflection');
    return (
        <>
            <ChatBotProvider>
                <Router>
                    <Navbar loadFresh id='navbar-main' setProfileOption={setProfileOption} profileOption={profileOption}/>
                    <Routes setProfileOption={setProfileOption} profileOption={profileOption} />
                </Router>
            </ChatBotProvider>
        </>
    );
};

export default App;
